import React from 'react'
import { useTranslation } from 'react-i18next'
import TransitPreviewSection from './TransitPreviewSection'
import TransitPreviewField from './TransitPreviewField'

interface TransitPreviewFeedbackSectionProps {
  feedback: string
}

function TransitPreviewFeedbackSection(props: Readonly<TransitPreviewFeedbackSectionProps>) {
  const { t } = useTranslation()
  const { feedback } = props

  return (
    <TransitPreviewSection
      columnId="feedback"
      headingLabel={t('declaration.navbar.additional')}
    >
      <div className="col-6">
        <TransitPreviewField
          label={t('feedback.info')}
          value={feedback}
        />
      </div>
    </TransitPreviewSection>
  )
}

export default TransitPreviewFeedbackSection
